module.exports = __webpack_public_path__ + "static/media/weather1.49735f82.png";